import React, { useContext } from 'react';
import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';
import { Button } from '@thd-olt-component-react/button';
import { ProductPodGroupContext } from '../../ProductPodGroupContext';
import { ProductPodContext } from '../../ProductPodContext';

export const ProductSeeSimilarItems = () => {

  const {
    itemId,
    position,
    productPodRef,
    product,
    showSimilarItem
  } = useContext(ProductPodContext);

  const { isFulfillable } = podFulFillmentUtils;
  const { info } = product || {};
  const { isBuryProduct = false } = info || {};

  const {
    handleProductPodExpansion
  } = useContext(ProductPodGroupContext);

  const hideSimilarItemLink = isFulfillable(product) || !isBuryProduct;

  if ((!showSimilarItem && hideSimilarItemLink) || !handleProductPodExpansion) {
    return null;
  }

  return (
    <Button
      tag="a"
      className="similar-items-link"
      link
      onClick={() => handleProductPodExpansion(itemId, position, productPodRef)}
    >
      See similar items
    </Button>
  );
};

ProductSeeSimilarItems.displayName = 'ProductSeeSimilarItems';
